import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DocumentsContainerComponent } from './documents-container.component';
import { UIComponentsModule } from 'common/src/modules';
import { FiltersModule } from 'common/src/modules/filters';
import { TruncateTooltipModule } from '../../directives/truncate-tooltip/truncate-tooltip.module';
import { CollapseButtonsOnOverflowModule } from '../../directives/collapse-buttons-on-overflow/collapse-buttons-on-overflow.module';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';


@NgModule({
  declarations: [
    DocumentsContainerComponent
  ],
  exports: [
    DocumentsContainerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    UIComponentsModule,
    TranslateModule,
    PerfectScrollbarModule,
    FiltersModule,
    TruncateTooltipModule,
    CollapseButtonsOnOverflowModule,
    IconButtonModule,
  ]
})
export class DocumentsContainerModule { }
